import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../Button';

import './style.scss';

export interface ReplyButtonProps {
  onClick: () => void;
}

const ReplyButton: React.FC<ReplyButtonProps> = (props) => {
  const { onClick } = props;

  const { t } = useTranslation();

  return (
    <Button
      className="ReplyButton"
      iconOnly
      icon="balloon"
      aria-label={t('pages.forum.reply_comment.button')}
      onClick={onClick}
    />
  );
};

export default ReplyButton;
